<ng-container *ngIf="isVisible">
    <button
        mat-button
        [id]="field.id"
        type="button"
        [disabled]="field.disabled || isReadOnly"
        [matTooltip]="field.tooltip ? (field.tooltip | translate) : ''"
        [ngClass]="field.panelClass"
        (click)="onButtonAction($event)"
    >
        <mat-icon *ngIf="field.iconName">{{ field.iconName }}</mat-icon>
        <img
            *ngIf="field.imgSrc"
            [ngSrc]="field.imgSrc"
            [height]="field.imgHeight || suffixImgSize"
            [width]="field.imgWidth || suffixImgSize"
            [alt]="field.imgAlt || ''"
            [ngClass]="field.imgClass"
        />
        <span class="btn-label">
            {{ field.label | translate }}
        </span>
        <span *ngIf="field.suffixText" [ngClass]="field.suffixTextClass"> ({{ field.suffixText | translate }}) </span>
    </button>
</ng-container>
